<template>
  <div class="el-form-item" :class="{'is-error': hasError, 'app-row-input-no-error-space': noErrorSpace}">
    <div class="el-form-item__content">
      <div class="app-row-input__input">
        <app-input
          slot="reference"
          ref="input"
          v-if="computedType"
          :type="computedType"
          v-model="model"
          :placeholder="computedPlaceholder"
          :options="computedOptions"
          :readonly="readonly"
          :disabled="disabled"
          @app-event="onAppEvent"/>
      </div>
      <div v-show="errorMessage" class="el-form-item__error">{{errorMessage}}</div>
    </div>
  </div>
</template>

<style scoped>
.app-row-input__input{
  height:24px;
  line-height:22px;
}
.el-form-item {
  margin-top: 2px;
  margin-bottom: 10px;
}
.el-form-item.app-row-input-no-error-space {
  margin-bottom: 2px;
}
</style>

<script>
/* eslint-disable semi */
import { Component, Prop, Inject, Provide, Watch } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

const debug = process.env.NODE_ENV === 'development';

@Component
export default class AppRowInput extends AppComponent {
  // 上位のテーブルコンポーネントで公開されたテーブルデータを参照
  @Inject('_app_table') table;

  @Prop({ required: true })
  row;

  @Prop({ required: true })
  prop;

  @Prop({ required: false, default: null })
  type;

  @Prop({ required: false, default: null })
  placeholder;

  @Prop({ required: false, default: false })
  disabled;

  @Prop({ required: false, default: false })
  readonly;

  @Prop({ required: false, default: null })
  options;

  @Prop({ required: false, default: false })
  noErrorSpace;

  // AppFormと同一挙動のためのプロパティ エラー
  @Prop({ required: false, default: null })
  errors;

  data () {
    return {
      hasError: false
    }
  }

  /**
   * エラー監視
   * 反映されない場合は呼び出し元で$setを利用してください
   * 例）this.$set(errors, 'name', []);
   */
  @Watch('errors', {deep: true, immediate: true})
  onErrorsChange (value) {
    this.provide.errors = value;
    this.hasError = (this.errorMessage !== null && this.errorMessage !== undefined);
  }

  /**
   * エラーメッセージ取得
   */
  get errorMessage () {
    if (this.errors === null || this.errors === undefined) {
      return null;
    }
    if (this.prop in this.errors) {
      const propErrors = this.errors[this.prop];
      if (Array.isArray(propErrors)) {
        return (propErrors.length > 0) ? propErrors[0] : null;
      } else {
        return propErrors;
      }
    }
  }

  // 入力要素種別取得
  get computedType () {
    if (this.type !== null) {
      return this.type;
    } else {
      if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('type' in this.schema.props[this.prop])) {
        return this.schema.props[this.prop].type;
      } else {
        return null;
      }
    }
  }

  // Placeholder取得
  get computedPlaceholder () {
    if (this.placeholder !== null) {
      return this.placeholder;
    } else {
      if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('placeholder' in this.schema.props[this.prop])) {
        return this.schema.props[this.prop].placeholder;
      } else {
        return null;
      }
    }
  }

  // options取得
  get computedOptions () {
    // 下記をマージして返却する
    // スキーマで定義されたオプション
    // 要素に直接指定されたオプション
    let options = {};
    if ((this.schema !== null) &&
        (this.schema.props) &&
        (this.prop in this.schema.props) &&
        ('options' in this.schema.props[this.prop])) {
      options = Object.assign(options, this.schema.props[this.prop].options);
    }
    if (this.options !== null) {
      options = Object.assign(options, this.options);
    }
    return options;
  }

  get model () {
    return this.row[this.prop];
  }

  set model (value) {
    // プロパティが不完全なモデル検知
    if (debug && (this.row) && (!(this.prop in this.row))) {
      console.warn(`Model has not prop [${this.prop}]`);
    }

    this.row[this.prop] = value;
    this.$emit('input', value);
  }

  get schema () {
    return this.table.schema;
  }

  /**
   * 下層コンポーネントへの公開プロパティ定義
   * ※AppFormと同じ_app_form という名称で公開する
   */
  provide = {
    model: {},
    errors: {},
    validateField: null,
    schema: null
  }
  @Provide('_app_form') val = this.provide;

  /**
   * LifeCycleイベント
   */
  created () {
    // 下層コンポーネントへの公開プロパティを設定する
    // mountedのタイミングでは、先に下層コンポーネントの初期化が行われるので問題がある。
    this.provide.model = this.row;
    this.provide.errors = this.errors;
    this.provide.schema = this.schema;
    this.provide.validateField = (props) => {
      // this.$refs.form.validateField(props);
    };

    // this.resetInnerRules();
  }

  /**
   * 下層コンポーネントへの公開プロパティ更新
   */
  @Watch('row')
  onChangeRow (value) {
    this.provide.model = value;
  }

  /**
   * 下層コンポーネントへの公開プロパティ更新
   */
  @Watch('errors')
  onChangeErrors (value) {
    this.provide.errors = value;
  }

  // 親コンポーネントへの透過イベント
  onAppEvent (...args) {
    // propに対してバリデーションを実行する
    if (args[0] === 'require:validate') {
      // TODO バリデーションはどうするか検討
    }
    // エンターキーイベント
    // プロパティ名を付加してemitする
    if (args[0] === 'enterkey') {
      this.$emit('app-event', ...args, this.prop);
      return;
    }
    this.$emit('app-event', ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppRowInput.vue